import { useRef, useEffect } from "react";

export const useUpdateEffect = (fn, deps) => {
  const ref = useRef(false);

  useEffect(() => {
    ref.current ? fn() : (ref.current = true);
  }, deps);
};
